export const VIEW_ITEM_TILE = "item_tile";
export const VIEW_PRODUCT_LIST = "product_list";
export const VIEW_PRODUCT_DETAILS = "product_details";
export const ORDER_DETAILS = "order_details";
export const WORKING_ORDER_ITEMS = "working_order_items";
